export default __webpack_public_path__ + "static/media/mt3.63270265.png";